// @ts-nocheck
import t from '@/store/types';

export const initSubscriptionPlans = () => ({
  type: t.INIT_SUBSCRIPTION_PLANS
});